import { SocialMediaInstagramPreviewController } from './social-media-instagram-preview.controller'

function socialMediaInstagramPreview () {
  return {
    restrict: 'E',
    controller: SocialMediaInstagramPreviewController,
    templateUrl: '/arts/directives/social-media-instagram-preview/social-media-instagram-preview.html?$$REVISION$$',
    scope: {
      previewType: '<',
      imageUrl: '<',
      caption: '<',
      materials: '<',
      selectedIndex: '<'
    }
  }
}

export { socialMediaInstagramPreview }
